import { handleActions } from '@mendeley-internal/lib-js-redux-actions';
import { searchDocuments, getDocument } from '../actions/document';
import { getEntitlement } from '../actions/entitlements';

export default handleActions({
  [searchDocuments]: {
    next(state, { payload }) {
      return payload.items.reduce((newState, doc) => ({
        ...newState,
        [doc.id]: doc
      }), state);
    }
  },
  [getDocument]: {
    next(state, { payload, payload: { id } }) {
      return {
        ...state,
        [id]: payload
      };
    }
  },
  [getEntitlement]: {
    next(state, { payload: { catalogId, entitled } }) {
      return {
        ...state,
        [catalogId]: {
          ...state[catalogId],
          isEntitledToPdf: entitled,
        },
      };
    }
  }
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/documents.js